var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllEmpty = function SvgAllEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2042_33933)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#F5F4EE",
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF1424",
    d: "M58.4 59.6c-14.249 0-25.8 11.551-25.8 25.8s11.551 25.8 25.8 25.8 25.8-11.551 25.8-25.8-11.551-25.8-25.8-25.8M24 85.4C24 66.401 39.401 51 58.4 51s34.4 15.401 34.4 34.4a34.25 34.25 0 0 1-7.225 21.094l23.166 23.165a4.302 4.302 0 0 1-6.082 6.082l-23.165-23.166A34.25 34.25 0 0 1 58.4 119.8c-18.999 0-34.4-15.401-34.4-34.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M88 28.12a8.86 8.86 0 0 1 2.627-3.997 8.65 8.65 0 0 1 4.295-2.014 8.6 8.6 0 0 1 4.699.564 8.73 8.73 0 0 1 3.714 2.976 8.94 8.94 0 0 1 1.638 4.51 9 9 0 0 1-.923 4.715 8.8 8.8 0 0 1-3.21 3.531 8.6 8.6 0 0 1-4.553 1.305v2.213m.109 8.855V51h-.217v-.222z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2042_33933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#fff",
    rx: 20
  })))));
};
export default SvgAllEmpty;